import styled from "@emotion/styled";

export const ProjectWrapper = styled.div`
    background-color: black;
    background-size: cover;
  background-repeat: no-repeat;
  background-position: center; 
  min-height: 100vh;
`;
